import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, List, Avatar, Typography, Card, Divider, Space } from "antd";
import {
  UserOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import api from "../../../axiosConfig";

const { Text } = Typography;

function HistorialConductorDialog({ open, onClose, conductorId }) {
  const [historial, setHistorial] = useState([]);

  useEffect(() => {
    if (conductorId && open) {
      // Obtener el historial del conductor
      api
        .get(`/conductores/historial/${conductorId}`)
        .then((response) => {
          setHistorial(response.data);
        })
        .catch((error) => {
          console.error("Error al obtener el historial:", error);
        });
    }
  }, [conductorId, open]);

  const getIconByAction = (action) => {
    switch (action) {
      case "Creación de Conductor":
        return <UserOutlined style={{ color: "#4CAF50" }} />;
      case "Actualización de Conductor":
        return <CheckCircleOutlined style={{ color: "#FFC107" }} />;
      case "Eliminación de Conductor":
        return <CloseCircleOutlined style={{ color: "#F44336" }} />;
      default:
        return <ClockCircleOutlined style={{ color: "#1976D2" }} />;
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <Text strong style={{ color: "#2E3B4E" }}>
          Historial del Conductor
        </Text>
      }
      footer={null}
      width={800}
      centered
      style={{ borderRadius: "15px" }}
    >
      <div style={{ backgroundColor: "#f9f9f9", padding: "20px" }}>
        <List
          itemLayout="vertical"
          dataSource={historial}
          renderItem={(registro, index) => (
            <div key={registro.id}>
              <Card
                style={{ borderRadius: "8px", backgroundColor: "#fff" }}
                variant="borderless"
              >
                <List.Item>
                  <Space align="start" size="large">
                    <Avatar style={{ backgroundColor: "#3F51B5" }}>
                      {registro.usuario?.nombre?.charAt(0) || '?'}
                    </Avatar>
                    <div>
                      <Text
                        strong
                        style={{ color: "#2E3B4E", fontSize: "16px" }}
                      >
                        {`${registro.usuario?.nombre || 'Usuario desconocido'} - ${registro.accion}`}
                      </Text>
                      <Text
                        style={{
                          display: "block",
                          marginTop: "8px",
                          marginBottom: "8px",
                        }}
                      >
                        {registro.descripcion}
                      </Text>
                      <Space>
                        {getIconByAction(registro.accion)}
                        <Text type="secondary">
                          {new Date(registro.fecha).toLocaleString()}
                        </Text>
                      </Space>
                    </div>
                  </Space>
                </List.Item>
              </Card>
              {index < historial.length - 1 && <Divider />}
            </div>
          )}
        />
      </div>
    </Modal>
  );
}

HistorialConductorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  conductorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default HistorialConductorDialog;
